/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Upload_Pdf_Or_DocumentInputs */

const en_common_upload_pdf_or_document = /** @type {(inputs: Common_Upload_Pdf_Or_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a PDF or document`)
};

const es_common_upload_pdf_or_document = /** @type {(inputs: Common_Upload_Pdf_Or_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir PDF o documento`)
};

/**
* | output |
* | --- |
* | "Upload a PDF or document" |
*
* @param {Common_Upload_Pdf_Or_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_upload_pdf_or_document = /** @type {((inputs?: Common_Upload_Pdf_Or_DocumentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Upload_Pdf_Or_DocumentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_upload_pdf_or_document(inputs)
	return en_common_upload_pdf_or_document(inputs)
});